<template>
  <div>
    <b-container class="home-container container-xl text-left">
      <b-row class="mb-2">
        <b-col cols="12" class="mb-3 mb-lg-5">
          <h1>Széchenyi Programiroda</h1>
        </b-col>
        <b-col cols="12" class="mt-lg-4">
          <h3>Megbízható partnere az egyéni és társas vállalkozásoknak.</h3>
        </b-col>
        <b-col class="col-12 col-md-10 mt-3 mt-lg-5">
          <p>
            A Széchenyi Programiroda Nonprofit Kft. (SZPI) egy széleskörű nemzetközi és hazai tapasztalatokkal
            rendelkező állami szolgáltató centrum az uniós támogatások és pályázatok világában, amelynek sokrétű
            szolgáltatásai bárki számára közvetlenül és ingyenesen vehetők igénybe. Az SZPI elsődleges célja és feladata
            a pályázók tájékoztatása és támogatása az európai uniós pályázatokkal kapcsolatban.
          </p>
        </b-col>
      </b-row>
      <b-row class="mb-5">
        <b-col cols="12">
          <b-row>
            <b-col class="col-12 col-md-6 szpi-list">
              <img style="width: 32px;" src="../assets/img/logo/vekonyvali_hollow2.svg" class="mr-4" />
              <p>Évtizedes tapasztalat az európai uniós pályázati és projektmenedzsment világban</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 szpi-list">
              <img style="width: 32px;" src="../assets/img/logo/vekonyvali_hollow2.svg" class="mr-4" />
              <p>Országos elérhetőség</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 szpi-list">
              <img style="width: 32px;" src="../assets/img/logo/vekonyvali_hollow2.svg" class="mr-4" />
              <p>Teljeskörű segítség a pályázati tervtől a projektzárásig és a fenntartási időszak alatt</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 szpi-list">
              <img style="width: 32px;" src="../assets/img/logo/vekonyvali_hollow2.svg" class="mr-4" />
              <p>Térítésmentes szolgáltatás</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 szpi-list">
              <img style="width: 32px;" src="../assets/img/logo/vekonyvali_hollow2.svg" class="mr-4" />
              <p>Nemzetközi együttműködési projektek</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-card-group>
          <b-col class="text-center" md="12" lg="4" v-for="(c, index) in consultations" :key="index">
            <b-card
              tag="article"
              class="mb-2"
              v-bind:class="{
                red: index === 0,
                blue: index === 1,
                green: index === 2,
                active: c.active
              }"
              @click="activeConsultation(index)"
            >
              <b-card-title> {{ c.name }} </b-card-title>
            </b-card>
          </b-col>
        </b-card-group>
      </b-row>
      <div class="answers">
        <b-row>
          <b-col cols="12">
            <p class="title mb-4">
              Milyen kérdésekben segít az SZPI?
            </p>
          </b-col>
        </b-row>
        <div v-if="consultations[0].active">
          <b-row class="mb-4">
            <b-col sm="12" md="6">
              <p>Jogosultsági szempontok áttekintése - (Jogosult-e a cégem a pályázatra?)</p>
            </b-col>
            <b-col sm="12" md="6">
              <p>
                Testreszabott tájékoztatás az elérhető források pontos feltételeiről - (Milyen szempontoknak kell
                megfeleljek?)
              </p>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col sm="12" md="6">
              <p>
                Cége eredményei alapján reálisan elérhető pontszámok - (A cégem eredményei milyen pontszámot hozhatnak?
                Érdemes-e belevágnom?)
              </p>
            </b-col>
            <b-col sm="12" md="6">
              <p>
                Tervezési tippek, javaslatok, ütemezés, beszerzés, cash flow stb. – (Hogyan tervezzek megvalósítható
                költségvetést?)
              </p>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col sm="12" md="6">
              <p>Dokumentációs kötelezettségek - (Milyen dokumentumokat kell beadnom a pályázathoz?)</p>
            </b-col>
            <b-col sm="12" md="6">
              <p>Általános tájékoztatás egyes forráslehetőségekről (Hogyan épül fel a pályázati folyamat?)</p>
            </b-col>
          </b-row>
          <b-row align-h="center">
            <b-col sm="12" md="7" class="szpi-warning d-flex align-items-center justify-content-center mt-lg-5">
              <p class="mb-0">
                Az SZPI pályázatot nem ír, de segít a pályázati anyag adminisztratív és technikai összeállításában
              </p>
            </b-col>
          </b-row>
        </div>
        <div v-if="consultations[1].active">
          <b-row class="mb-4">
            <b-col sm="12" md="6">
              <p>Szerződéskötéshez szükséges dokumentációs segítség - (Mit kell benyújtanom a szerződéshez?)</p>
            </b-col>
            <b-col sm="12" md="6">
              <p>
                Teljesítendő mutatószámok és alátámasztásuk – (Mit kell teljesítsek, és hogyan igazolom azt?)
              </p>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col sm="12" md="6">
              <p>
                Útmutatás az EPTK (elektronikus pályázatkezelési felület) kezeléséhez – (Hogyan kell dokumentálnom
                elektronikusan?)
              </p>
            </b-col>
            <b-col sm="12" md="6">
              <p>
                Segítségnyújtás beszámolókhoz, kifizetési kérelmekhez – (Hogyan számolom el a számlákat és a felmerülő
                kiadásokat?)
              </p>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col sm="12" md="6">
              <p>Helyszíni ellenőrzésre való felkészítés – (Mire figyeljek, ha ellenőrzik a projektem?)</p>
            </b-col>
            <b-col sm="12" md="6">
              <p>
                Kérdések megválaszolása a projektmegvalósítással kapcsolatban – (Ha elakadtam a projektben, hogyan
                tovább?)
              </p>
            </b-col>
          </b-row>
        </div>
        <div v-if="consultations[2].active">
          <b-row class="mb-4">
            <b-col sm="12" md="6">
              <p>Projektzárásra, ellenőrzésekre való felkészülés - (Mire számítsak az ellenőrzéseknél?)</p>
            </b-col>
            <b-col sm="12" md="6">
              <p>
                Fenntartási kötelezettségek, dokumentációs elvárások, javaslatok archiváláshoz – (Mit kell megőrizzek,
                és meddig kell fenntartanom a megvalósult pályázatot?)
              </p>
            </b-col>
          </b-row>
        </div>
      </div>
      <b-row class="justify-content-md-center">
        <b-col sm="12" md="5" class="mt-5 mb-5">
          <b-button class="button" href="https://szpi.hu/irodakereso" target="_blank">
            SZPI tanácsadói segítséget kérek
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p class="last-paragraph">
            Az SZPI Nemzeti Programok Igazgatósága által üzemeltetett irodahálózat az ország számos pontján segíti az
            európai uniós források kedvezményezettjeit a projektek tervezése és végrehajtása során. Keresse fel az Önhöz
            legközelebb eső irodát, ahol az SZPI kollégái térintésmentesen nyújtanak segítséget az érdeklődőknek és
            pályázóknak egyaránt.
          </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'SzechenyiProgramirodaInformation',
  data() {
    return {
      consultations: [
        {
          name: 'Tanácsadás a pályázat elkészítése előtt',
          active: true
        },
        {
          name: 'A projekt sikeres megvalósítása',
          active: false
        },
        {
          name: 'Projektzárás és fenntartás',
          active: false
        }
      ]
    }
  },
  methods: {
    activeConsultation(activeIndex) {
      this.consultations.forEach((consultation, index) => {
        if (index === activeIndex) {
          consultation.active = true
        } else {
          consultation.active = false
        }
      })
    }
  }
}
</script>

<style scoped>
p {
  color: var(--color-gray-04);
}
p.title {
  color: var(--color-green);
  font-weight: bold;
}
.szpi-list {
  display: flex;
  align-content: center;
  align-items: center;
  padding: 15px;
  font-weight: bold;
}
.szpi-list p {
  margin-bottom: 0;
}

.button {
  background: #00903c;
  font-weight: 700;
  color: #fff;
  width: 100%;
  height: 44px;
  line-height: 29px;
  border-radius: 8px;
  margin-bottom: 0rem;
}

.last-paragraph {
  margin-top: -1rem;
}

.card {
  border: 0;
  border-radius: 8px;
  height: 280px;
  padding-top: 56px;
  padding-bottom: 56px;
  padding-right: 32px;
  padding-left: 32px;
}

.card.green {
  color: #00903c;
  border: 4px solid #00903c;
}
.card.green.active {
  color: #ffffff;
  background-color: #00903c;
}
.card.red {
  color: #ba3b46;
  border: 4px solid #ba3b46;
}
.card.red.active {
  color: #ffffff;
  background-color: #ba3b46;
}
.card.blue {
  color: #0484bb;
  border: 4px solid #0484bb;
}
.card.blue.active {
  color: #ffffff;
  background-color: #0484bb;
}
.card:hover {
  color: var(--white);
  cursor: pointer;
}
.green:hover {
  background-color: #00903c;
}

.card:hover.red {
  background-color: #ba3b46;
}

.card:hover.blue {
  background-color: #0484bb;
}

.card-body {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
}

.card-title {
  font-size: 30px;
  text-align: left !important;
  font-weight: bold;
  z-index: 1;
}
.card:before {
  content: ' ';
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  width: 100%;
  height: 57%;
  z-index: 0;
  background-image: url('../assets/img/logo/vekonyvali_hollow_outline2_red.svg');
  background-repeat: no-repeat;
  background-size: 154px;
  background-position: center;
}

.card.blue:before {
  background-image: url('../assets/img/logo/vekonyvali_hollow_outline2_blue.svg');
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.card.green:before {
  background-image: url('../assets/img/logo/vekonyvali_hollow_outline2_green.svg');
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}
.card-body {
  padding: 0.25rem !important;
  padding-bottom: 1.25rem !important;
  padding-top: 1.25rem !important;
  text-align: center;
}

.answers {
  margin-top: 24px;
  padding: 32px;
  background-color: #f2f8fa;
}

.szpi-warning {
  font-weight: bold;
  background: rgba(186, 59, 70, 0.2);
  border-radius: 8px;
  border-left: 8px solid rgba(186, 59, 70, 0.6);
  height: 80px;
  padding: 16px;
  margin-bottom: 32px;
}
@media (max-width: 768px) {
  .program-wrapper {
    margin-bottom: 1.5rem;
  }
}
</style>
